module.exports = __webpack_public_path__ + "static/media/twitter.4d220a99.svg";